export enum CartItemGroupVariantEnum {
    COMPACT = 'compact',
    FULL = 'full',
    MINI = 'mini',
}
